import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { useTheme } from '../hooks/useTheme.js';

/*
 * SolidCheckboxPath provides a base checkbox image for a checkbox with a solid colour. It does not
 * have a border stroke. We use this for checked and indeterminate checkboxes.
 */
var SolidCheckboxPath = function () { return (jsx("rect", { className: "cb-solid", x: "10", y: "10", width: "80", height: "80", rx: "12", ry: "12", fill: "#404040", stroke: "none" })); };
/*
 * BorderedCbPath provides a base checkbox image for a checkbox with different colours for
 * the border and background as seen in an unchecked checkbox.
 *
 * The border is an SVG `stroke` on the border of the main rectangle with the inner 50% of the
 * stroke overlaying the main rectangle. Because of this, if the stroke is transparent, the colour
 * of it's inner half is affected by the colour of the main rectangle. We use opacity to denote
 * a disabled checked and indeterminate checkboxes so this was not suitable for those.
 *
 * An attempt at using an "outer" stroke led to a faint line appearing between the stroke and the
 * main rectangle.
 */
var BorderedCbPath = function () { return (jsx("rect", { className: "cb-bordered", x: "12", y: "12", width: "76", height: "76", rx: "12", ry: "12", fill: "#404040", stroke: "#BFBFBF", strokeWidth: 5, strokeLinejoin: "round" })); };
var FocusPath = function () { return (jsx("rect", { className: "focus", x: "0", y: "0", width: "100", height: "100", rx: "16", ry: "16", fill: "#CCE0F5" })); };
var CheckPath = function () { return (jsx("path", { className: "check", d: "M42.303 59.426 L72.941 28.788 77.604 33.451 42.303 68.752 23.486 49.935 28.149 45.273 Z", fill: "currentColor", fillOpacity: "1", stroke: "none" })); };
var MinusPath = function () { return (jsx("path", { className: "minus", d: "M26.136 47.351 L73.864 47.351 73.864 52.654 26.136 52.654 Z", fill: "currentColor", fillOpacity: "1", stroke: "none" })); };
var CheckboxSvg = function (props) {
    var handleStyleProps = useTheme().handleStyleProps;
    var id = props.id, isIndeterminate = props.isIndeterminate, _a = props.themeKey, themeKey = _a === void 0 ? "checkboxSvg" : _a, forwardProps = __rest(props, ["id", "isIndeterminate", "themeKey"]);
    var svgCssProps = handleStyleProps(__assign({ isIndeterminate: isIndeterminate }, forwardProps), {
        themeKey: themeKey,
        baseStyle: { boxSizing: "border-box" },
    });
    if (isIndeterminate) {
        return (jsxs("svg", __assign({}, svgCssProps, { viewBox: "0 0 100 100", id: id, "data-testid": id }, { children: [jsx(FocusPath, {}), jsx(SolidCheckboxPath, {}), jsx(CheckPath, {}), jsx(MinusPath, {})] })));
    }
    return (jsxs("svg", __assign({}, svgCssProps, { viewBox: "0 0 100 100", id: id, "data-testid": id }, { children: [jsx(FocusPath, {}), jsx(SolidCheckboxPath, {}), jsx(BorderedCbPath, {}), jsx(CheckPath, {})] })));
};

export { CheckboxSvg };
//# sourceMappingURL=CheckboxSvg.js.map
